import { IAlert } from '@pra-vendas-themes/interfaces/IAlert';

import { useComponentsTheme } from 'hooks/useComponentsTheme';

import { WithChildren } from 'types/WithChildren';

export const Alert: WithChildren<IAlert> = ({ children, ...props }) => {
  const { Alert: AlertTheme } = useComponentsTheme();

  return <AlertTheme {...props}>{children}</AlertTheme>;
};
